import * as React from 'react';
import { MenuView, MenuViewProps, MobileMenuProps } from './Menu.view';
import { SecondaryMenuItemEnum } from '../../SecondaryNav/SecondaryNav.controller';
import { useState } from 'react';

export type MenuControllerProps = MobileMenuProps & {
  // extend your MenuViewProps
};

export const MenuController = (props: MenuControllerProps): JSX.Element => {
  const [visiblePanel, setVisiblePanel] = useState<SecondaryMenuItemEnum | null>(null);

  const viewProps: MenuViewProps = { ...props, visiblePanel, setVisiblePanel };

  return <MenuView {...viewProps} />;
};
